import {getToken, removeToken, setToken} from "@/api/cookie";

const state = () => ({
    isSetCookie : false
})

const getters = {}

const actions = {
    // 获取Token的action
    async getToken({ commit, dispatch }, params) {
        console.log(commit,params)
        await dispatch("loading/setLoading", true, { root: true })
        try {
            // 修正：直接获取token，不需要then/catch
            const token = getToken()
            console.log("获取到的token:", token)
        } catch (err) {
            console.log("获取token失败:", err)
        } finally {
            await dispatch("loading/setLoading", false, { root: true })
        }
    },

    // 设置Token的action
    async fetchSetToken({ commit, dispatch }, params) {
        await dispatch("loading/setLoading", true, { root: true })
        try {
            setToken(params.token_val, params.token_expired)
            commit("setIsSetCookie", params.token)
        } catch (err) {
            console.log("设置token失败:", err)
        } finally {
            await dispatch("loading/setLoading", false, { root: true })
        }
    },

    // 移除Token的action
    // async fetchRemoveToken({ commit, dispatch }) {
    //     console.log(commit)
    //     await dispatch("loading/setLoading", true, { root: true })
    //     try {
    //         removeToken()
    //         console.log("Token已移除")
    //     } catch (err) {
    //         console.log("移除token失败:", err)
    //     } finally {
    //         await dispatch("loading/setLoading", false, { root: true })
    //     }
    // },

    // 登出action - 修复Promise处理
    async fetchRemoveToken({ commit, dispatch }) {
        console.log(commit)
        await dispatch("loading/setLoading", true, { root: true })
        return new Promise((resolve) => {
            try {
                removeToken()
                // console.log("登出成功，Token已移除")
                commit("setIsSetCookie", false)
                resolve()
            } catch (err) {
                console.log("登出失败:", err)
            } finally {
                dispatch("loading/setLoading", false, { root: true })
            }
        })
    }
}

const mutations = {
    setIsSetCookie(state, isSetCookie){
        state.isSetCookie = isSetCookie
    }
}

// 导出模块
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}





// import Cookies from 'js-cookie'
//
// const TokenKey = 'good-token'
// export function getToken() {
//     return Cookies.get(TokenKey)
// }
// export function setToken(token) {
//     return Cookies.set(TokenKey, token);
// }
//
// // /*
// // * 设置Cookies
// // * */
// // export function setCookies (key, value, expiresTime) {
// //     let seconds = expiresTime
// //     let expires = new Date(new Date() * 1 + seconds * 1000)
// //     return Cookies.set(key, value, { expires: expires })
// // }
//
//
// export function setTokenWithExpiry(token,expirySecond){
//     const expiryDate = new Date(new Date().getTime() + expirySecond * 1000);
//     Cookies.set(TokenKey, token, { expires: expiryDate });
// }
// export function removeToken() {
//     return Cookies.remove(TokenKey);
// }
//
// const state = () => ({})
// // getters
// const getters = {}
// // actions
// const actions = {
//     // eslint-disable-next-line no-unused-vars
//     async getToken( { commit, dispatch } , params ) {
//         await dispatch("loading/setLoading", true, {root: true})
//         console.log("打印条件:",params)
//         getToken().then((res) => {
//             console.log(res)
//         }).catch((err) => {
//             console.log(err)
//         }).finally(async () => {
//             await dispatch("loading/setLoading", false, {root: true})
//         })
//     },
//     // eslint-disable-next-line no-unused-vars
//     async fetchSetToken( { commit, dispatch } , params ) {
//         await dispatch("loading/setLoading", true, {root: true})
//         console.log("打印条件:",params)
//         setTokenWithExpiry(params.token,params.expirySecond)
//     },
//     // eslint-disable-next-line no-unused-vars
//     async fetchRemoveToken( { commit, dispatch } ) {
//         await dispatch("loading/setLoading", true, {root: true})
//         removeToken()
//     },
//     async logout({ commit, dispatch } ) {
//         console.log(commit)
//         await dispatch("loading/setLoading", true, {root: true})
//         return new Promise((resolve) => {
//             removeToken()
//             resolve();
//             dispatch("loading/setLoading", false, {root: true})
//         });
//
//     },
// }
// // mutations
// const mutations = {}
// export default {
//     namespaced: true,
//     state,
//     getters,
//     actions,
//     mutations
// }
